"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const _ui_1 = require("@ui");
const uuid_1 = require("uuid");
require("./styles.scss");
const DIRECTIONS = Object.freeze({
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
});
const RadioGroup = ({ options, value, onChange, direction, disabled, label, }) => {
    const radioGroupId = react_1.default.useRef((0, uuid_1.v4)());
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD, text: label, color: disabled ? _ui_1.Text.COLORS.GRAY_LIGHT : _ui_1.Text.COLORS.DEFAULT }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.VERTICAL }))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('radio-group', direction, disabled) },
            react_1.default.createElement("div", { className: 'hidden' },
                react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.radioChecked })),
            options.map((option, index) => {
                return (react_1.default.createElement("div", { key: `${radioGroupId.current}-${index}`, className: 'radio-option', onClick: () => !disabled && !option.disabled ? onChange?.(option.value) : null },
                    react_1.default.createElement(_ui_1.Icon, { color: _ui_1.Icon.COLORS.PRIMARY, ico: value === option.value
                            ? _ui_1.Icon.ICONS.radioChecked
                            : _ui_1.Icon.ICONS.radioUnchecked, size: _ui_1.Icon.SIZES.SMALL, disabled: disabled || option.disabled }),
                    react_1.default.createElement("div", { className: 'text' + (option.disabled ? ' disabled' : '') }, option.label)));
            }))));
};
exports.RadioGroup = RadioGroup;
exports.RadioGroup.DIRECTIONS = DIRECTIONS;
